"use client";

import React from "react";
import { Link } from "react-router-dom";
import { config } from "@/lib/config";
import SelfTrustHeader from "@/components/main/self-trust-header";

export const SelfTrust = ({ className }: { className: string }) => {
  return (
    <div className={className}>
      <Link to={`${config.basePath}/onbizalom`}>
        <SelfTrustHeader />
      </Link>
    </div>
  );
};
